import React from 'react';

import PropTypes from 'prop-types';

import IconGroup from 'components/projectForm/methodStatement/icons/components/IconGroup';

import { resourceShape } from 'components/helpers/serialisableResources';

export default function IconGroupsContainer({ domainIconGroups, projectId }) {
  return (
    <div>
      {domainIconGroups.data.map((domainIconGroup) => (
        <IconGroup
          domainIconGroup={domainIconGroup}
          domainIcons={domainIconGroups.included.filter(
            (domainIcon) =>
              domainIcon.relationships.iconGroup.data.id === domainIconGroup.id,
          )}
          key={domainIconGroup.id}
          projectId={projectId}
        />
      ))}
    </div>
  );
}

IconGroupsContainer.propTypes = {
  domainIconGroups: PropTypes.shape({
    data: PropTypes.arrayOf(resourceShape('iconGroup')).isRequired,
    included: PropTypes.arrayOf(resourceShape('icon')).isRequired,
  }),
  projectId: PropTypes.string.isRequired,
};
